import React from 'react';
import { useTranslation } from 'react-i18next';
import TicketForm from './TicketForm';
import { PageHeaderCustom } from '../../components';

const EditAndCreate = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeaderCustom title={t(`tickets.create.ticketInfo`)} />
      <TicketForm />
    </>
  );
};

export default EditAndCreate;
